import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { OrganizationCreateForm } from "./OrganizationCreateForm";
import { PageHeader } from "@/components/layout/PageHeader";

export function OrganizationCreatePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="console-page space-y-6">
      <PageHeader title={t("header.createCustomer")} description={t("organizationRequired.description")} />
      <div className="max-w-3xl">
        <OrganizationCreateForm onCancel={() => navigate("/console/dashboard")} />
      </div>
    </div>
  );
}
